import { TableBody } from "@mui/material";
import React from "react";

const MainTableBody = ({ children, isLoading, noDivider }) => {
  return (
    <TableBody
      className={`${
        noDivider ? "" : "divide-y  divide-gray-200"
      }  justify-start text-black transition-all w-screen ${
        isLoading ? "opacity-50" : "opacity-100"
      }`}
    >
      {children}
    </TableBody>
  );
};

export default MainTableBody;
